import { render } from "./userActivations.vue?vue&type=template&id=447c656e"
import script from "./userActivations.vue?vue&type=script&lang=js"
export * from "./userActivations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__